import { start } from 'qiankun';
import { registerMicroAppsFn } from '../qiankun/config';
// console.log(window,'sub-container')
// 111111111
export default {
  mounted() {
    if (!window.qiankunStarted) {
      window.qiankunStarted = true;
      registerMicroAppsFn();
      start({
        sandbox: {
          experimentalStyleIsolation: true
        }
      });
    }
  }
};